import { Routes } from "@angular/router";

import { HomeComponent } from './home';
import { ViewComponent } from './_viewComponent/view.component'
import { LoginComponent, RegisterComponent } from './account';
import { authGuard } from './_helpers';

const usersRoutes = () => import('./users/users.routes').then(x => x.USERS_ROUTES);
const devicesRoutes = () => import('./devices/devices.routes').then(x => x.DEVICES_ROUTES);
const actionsRoutes = () => import('./actions/actions.routes').then(x => x.ACTIONS_ROUTES);
const tasksRoutes = () => import('./tasks/tasks.routes').then(x => x.TASKS_ROUTES);
const appsRoutes = () => import('./apps/apps.routes').then(x => x.APPS_ROUTES);
const syslogsRoutes = () => import('./syslogs/syslogs.routes').then(x => x.LOGS_ROUTES);

export const APP_ROUTES: Routes = [
    { path: 'users', loadChildren: usersRoutes, canActivate: [authGuard] },
    { path: 'devices', loadChildren: devicesRoutes, canActivate: [authGuard] },
    { path: 'actions', loadChildren: actionsRoutes, canActivate: [authGuard] },
    { path: 'tasks', loadChildren: tasksRoutes, canActivate: [authGuard] },
    { path: 'apps', loadChildren: appsRoutes, canActivate: [authGuard] },
    { path: 'syslogs', loadChildren: syslogsRoutes, canActivate: [authGuard] },
    { path: 'account/login', component: LoginComponent },
    { path: 'account/register', component: RegisterComponent },
    { path: ':ref/:id', component: ViewComponent },
    { path: '', component: HomeComponent, canActivate: [authGuard] },

    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];
